import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api/client';
import type { ApiDealResponse } from './types';

/**
 * Detalhe completo de um Deal (GET /api/deals/{id}) — enriquece o drawer da ficha com os campos
 * que a listagem não traz (resumo da tese, tags, pasta na rede, datas). Só dispara com id.
 */
export function useDeal(id: string | null) {
  return useQuery({
    queryKey: ['deal', id],
    queryFn: () => apiFetch<ApiDealResponse>(`/api/deals/${id}`),
    enabled: id != null,
  });
}
